import { Component, Input, OnInit } from "@angular/core";

import { Subject, Subscription } from "rxjs";
import { map, withLatestFrom } from "rxjs/operators";

import { ApplicationService, StorageService } from "../../../core/services";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @Input()
  title: string;

  isMobile: boolean = this.applicationService.isMobile;

  toggleMenuClick$: Subject<void> = new Subject();

  subscriptions: Subscription[] = [];

  constructor(
    private applicationService: ApplicationService,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.toggleMenuClick$
        .pipe(withLatestFrom(this.applicationService.isMenuOpened$))
        .subscribe(([_, isMenuOpened]) => {
          this.applicationService.isMenuOpened$.next(!isMenuOpened);
          this.storageService.set(
            "isDesktopNavigationMenuOpened",
            JSON.stringify(!isMenuOpened)
          );
        }),

      // restore menu state on page reloaded
      this.storageService
        .get("isDesktopNavigationMenuOpened")
        .pipe(map((isMenuOpened) => JSON.parse(isMenuOpened)))
        .subscribe((isMenuOpened) => {
          this.applicationService.isMenuOpened$.next(isMenuOpened);
        })
    );
  }

  toggleMenu() {
    this.toggleMenuClick$.next();
  }
}
